<template>
    <div>
      <b-form-group id="input-group-1" label="Nombre de usuario:" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="user.username"
          name="username"
          v-validate="'required|min:3 '" 
          :state="$parent.validateState('username')"
          placeholder="Tu respuesta"
        ></b-form-input>

        <b-form-invalid-feedback>
          {{  errors.first('username') }}
        </b-form-invalid-feedback>

      </b-form-group>

      <b-form-group id="input-group-2" label="Contraseña:" label-for="input-2">
        <b-form-input
          id="input-2"
          type="password"
          v-model="user.password"
          name="password"
          v-validate="'required|min:3'"
          :state="$parent.validateState('password')"
          placeholder="Tu respuesta"
        ></b-form-input>
        <b-form-invalid-feedback>
          {{  errors.first('password') }}
        </b-form-invalid-feedback>

      </b-form-group>

      <b-form-group id="input-group-3" label="Nombre completo:" label-for="input-3">
        <b-form-input
          id="input-3"
          v-model="user.nombre"
          name= "nombre"
          v-validate="'required'"
          :state="$parent.validateState('nombre')"
          placeholder="Tu respuesta"
        ></b-form-input>
        <b-form-invalid-feedback>
          {{  errors.first('nombre') }}
        </b-form-invalid-feedback>
      </b-form-group>
      
      <b-form-group id="input-group-8" label="Email:" label-for="input-8">
        <b-form-input
          id="input-8"
          v-model="user.email"
          placeholder="Tu respuesta"
        ></b-form-input>
      </b-form-group> 

      <b-form-group id="input-group-9" label="Télefono:" label-for="input-9">
        <b-form-input
          id="input-9"
          v-model="user.telefono"
          placeholder="Tu respuesta"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-10" label="Rol del usuario:" label-for="input-10">
        <b-form-select 
          v-model="user.rol_id" 
          :options="options" 
          size="sm"
          name="rol"
          v-validate="'required'"
          :state="$parent.validateState('rol')"
          ></b-form-select>
          <b-form-invalid-feedback>
              {{errors.first('rol')}}
          </b-form-invalid-feedback>
       </b-form-group>
      
      <b-form-group id="input-group-11" label="Vendedor SAP:" label-for="input-11">
        <b-form-select 
          v-model="user.vsap" 
          :options="vendedorsap" 
          size="sm"
          name="vsap"
          v-validate="'required'"
          :state="$parent.validateState('vsap')"
          ></b-form-select>
          <b-form-invalid-feedback>
              {{errors.first('vsap')}}
          </b-form-invalid-feedback>
       </b-form-group>

    </div>
</template>

<script>
    export default {
      inject:['$validator'],//para que el padre inyecte el validador a este componente hijo.
      props:{
        user:{
          type: Object,
          required:true
        },
        options:{
          type: Array,
          required:true
        },
        vendedorsap: {
          type: Array,
          required:true
        }
      }

        
    }
</script>

<style lang="scss" scoped>

</style>